/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';
import { compose } from 'redux';

class Modal extends React.Component {
	constructor(props) {
		super(props);

		this.keyListener = this.keyListener.bind(this);

	}

	componentDidMount(){
		if (this.props.hasBackground) {
	    	document.body.classList.add('modal-open');
		}

		if (this.props.showClose && this.props.hasBackground) {
			window.location.hash = "modal";
			window.addEventListener('keyup', this.keyListener);
		}
			
	}

	componentDidUpdate() {
		if (this.props.showClose && 
			this.props.hasBackground && 
			window.location.hash !== "#modal") {
			this.props.close();
		}
	}

	componentWillUnmount(){
		if (this.props.hasBackground) {
	    	document.body.classList.remove('modal-open');
		}

		if (window.location.hash.match("#modal")) {
			let cleanUrl = window.location.href.substring(0, window.location.href.indexOf("#"));
        	window.history.replaceState({}, '', cleanUrl);
		}

		if (this.props.showClose && this.props.hasBackground) {
			window.removeEventListener('keyup', this.keyListener);
		}
	}

	keyListener(e) {
		// catch esc and close the window
		// event should only be bound to modals that can be closed
        if (e.keyCode === 27) {
            this.props.close();
        }
    }

	render(){
		let footerContent = null,
			menuContent = null,
			contentClass = classnames('dlvr-modal-content', this.props.contentClass, {
				'with-menu': (this.props.menuContent === null) ? false : true,
				'with-footer': (this.props.footerContent === null) ? false : true
			}),
			mainClass = classnames('dlvr-modal-main', this.props.mainClass),
			boxClass = classnames('dlvr-modal-box', this.props.boxClass),
			wrapperClass = 'dlvr-modal',
			closeButton = null,
			headerClass = 'dlvr-modal-head';

		if (this.props.showClose) {
			closeButton = (
				<div className="dlvr-modal-close" onClick={this.props.close} role="button" aria-label="close dialog"><i className="fa fa-times"></i></div>
			);
		}

		if (this.props.lightBackground) {
			wrapperClass += ' light';
		}

		if (this.props.menuContent !== null) {
			menuContent = (
				<div className="dlvr-modal-menu">
					{this.props.menuContent}
				</div>
			);
		}

		if (this.props.footerContent !== null) {
			footerContent = (
				<div className="dlvr-modal-footer">
					{this.props.footerContent}
				</div>
			);
		}

		if (!this.props.hasBackground) {
			wrapperClass = "dlvr-modal-floating";
			closeButton = null;
		}

		if (this.props.wrapperClass !== '') {
			wrapperClass += " " + this.props.wrapperClass;
		}

		if (this.props.transparentHeader) {
			headerClass += " transparent";
		}

		return(
			<div className={wrapperClass} role="dialog" aria-hidden="false">
				<div className={boxClass}>
					<div className={headerClass}>
						{closeButton}
						<h1 className="modal-title">{this.props.headerContent}</h1>
					</div>
					<div className={mainClass}>
						{menuContent}
						<div className={contentClass}>
							{ this.props.content }
						</div>
						{footerContent}
					</div>
				</div>
			</div>
		);
	}
};

Modal.displayName = "Modal";

Modal.propTypes = {
	close: PropTypes.func,
	menuContent: PropTypes.element,
	headerContent: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.string
	]),
	content: PropTypes.element,
	footerContent: PropTypes.element,
	mainClass: PropTypes.string,
	boxClass: PropTypes.string,
	contentClass: PropTypes.string,
	hasBackground: PropTypes.bool,
	showClose: PropTypes.bool,
	wrapperClass: PropTypes.string
};

Modal.defaultProps = {
	close: () => {},
	menuContent: null,
	headerContent: null,
	content: null,
	footerContent: null,
	mainClass: '',
	boxClass: '',
	contentClass: '',
	hasBackground: true,
	lightBackground: false,
	showClose: true,
	wrapperClass: ''
};

const enhance = compose(
	ComponentWithRouter
);

export default enhance(Modal);
